import React, { Component } from 'react';
import classNames from "classnames";
import { Icons } from '../common/icons/menu';
import './js/jquery-3.4.1'
import './js/bootstrap-timepicker.js';
import './js/time-picker';
import "./css/time-picker.css";
import $ from './js/jquery-3.4.1';
import moment from 'moment';

// function formatTime({ hour, minutes }) {
//     if (hour == null || minutes == null) return '';
//     const timeString = `${String(hour).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
//     const parsed = moment(timeString, 'HH:mm');
//     return parsed.isValid() ? parsed.format('LT') : '';
// }

class TimePicker extends Component {
    state = {
        isOpenWidget: false,
    }

    componentDidMount() {
        const { id, minuteStep = 15, value } = this.props;
        const timePicker = $(`#${id}`);

        timePicker.timepicker({
            minuteStep,
            snapToStep: true,
            showInputs: false,
            disableFocus: false,
            showMeridian: true,
            defaultTime: '',
            icons: {
                up: '<svg aria-hidden="true" style="width: 32px; height: 32px;" focusable="false" data-prefix="fas" data-icon="chevron-up" class="svg-inline--fa fa-chevron-up fa-w-14 text-primary" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M240.971 130.524l194.343 194.343c9.373 9.373 9.373 24.569 0 33.941l-22.667 22.667c-9.357 9.357-24.522 9.375-33.901.04L224 227.495 69.255 381.516c-9.379 9.335-24.544 9.317-33.901-.04l-22.667-22.667c-9.373-9.373-9.373-24.569 0-33.941L207.03 130.525c9.372-9.373 24.568-9.373 33.941-.001z"></path></svg>',
                down: '<svg aria-hidden="true" style="width: 32px; height: 32px;" focusable="false" data-prefix="fas" data-icon="chevron-down" class="svg-inline--fa fa-chevron-down fa-w-14 text-primary" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="currentColor" d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"></path></svg>'
            }
        });

        timePicker.on('changeTime.timepicker', (e) => {
            this.setTime(e.time.value);
        });

        $(`#${id}`).on('show.timepicker', () => {
            if (this.props.value) {
                this.syncTimepicker(this.props.value);
            }
        });

        if (value) {
            this.setInputValue(value);
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.value !== prevProps.value) {
            this.setInputValue(this.props.value);
        }
    }

    setInputValue = (value) => {
        const { id } = this.props;
        if (value) {
            $(`#${id}`).val(moment(value, "HH:mm").format('LT'));
            // const m = moment.isMoment(value) ? value : moment(value, "HH:mm");
            // $(`#${id}`).val(m.format('LT'));
        } else {
            $(`#${id}`).timepicker('clear');
        }
    }

    syncTimepicker = (value) => {
        const { id } = this.props;

        if (!value) {
            $(`#${id}`).timepicker('clear');
            return;
        }

        const m = moment.isMoment(value) ? value : moment(value);
        const str = m.locale('en').format('h:mm A'); // this is the format that the timepicker understands
        $(`#${id}`).timepicker('setTime', str);     // 👈 this updates its internal state
    };

    setTime = (timeString) => {
        const regexHour = /\d+:/;
        const regexMinutes = /:[\d]{2}/;
        const [, meridian] = timeString.split(' ');

        let hour = timeString.match(regexHour)[0].slice(0, -1);
        const minutes = timeString.match(regexMinutes)[0].slice(1);

        if (hour === '12' && meridian === 'PM') {
            // nada
        } else if (hour === '12' && meridian === 'AM') {
            hour = '0';
        } else if (meridian === 'PM') {
            hour = (+hour + 12).toString();
        }

        if (this.props.onChange) {
            this.props.onChange({ hour, minutes });
        }
    }

    showWidget = () => {
        if (!this.state.isOpenWidget) {
            this.setState({ isOpenWidget: true });
            $(`#${this.props.id}`).timepicker('showWidget');
        }
    }

    render() {
        const { id, placeholder, style, className, disabled, inModal = false, value } = this.props;

        return (
            <div className={`${inModal ? 'm-2' : ''} d-flex input-group bootstrap-timepicker timepicker`}>
                <input
                    id={id}
                    type="text"
                    style={style}
                    defaultValue={value ? value.format("LT A") : ""}
                    placeholder={placeholder}
                    disabled={disabled}
                    autoComplete="off"
                    onClick={this.showWidget}
                    className={classNames(`form-control time-picker-input ${className ? className : ''}`)}
                />
                <span className="d-flex justify-content-center align-items-center input-group-addon"
                    style={{ width: "1.5rem", fontSize: "1rem", height: (style && style.height) || '100%' }}
                >
                    <Icons.IconTime className="h-100 w-100 d-flex align-items-center" />
                </span>
            </div>
        );
    }
}

export default TimePicker;
